// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bfm_a bih_bk bih_bl bih_bo","SwipeLeftToClose--animating":"bfm_b"};